<div class="modal-header">
  <h4 class="modal-title">Assign Customers</h4>
</div>
<div class="modal-body">
  <section>
    <div class="tabs-Section-Container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 large-Device-Tabs">
          <ul class="nav nav-tabs">
            <li class="nav-item" [ngClass]="{
            'nav-Item-Border': tabSelected == 'Numbers'
          }">
              <p (click)="tabNavigation('Numbers')">Enter numbers</p>
            </li>
            <li class="nav-item" [ngClass]="{ 'nav-Item-Border': tabSelected == 'Search' }">
              <p (click)="tabNavigation('Search')"> Search list </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab-contents">
      <div id="Numbers">
        <div class="search-box">
          <input type="text" name="numberbox" #numberbox placeholder="Enter customer number(s) here"
            (paste)="numberSearchCustomer($event)">
        </div>
        <div class="loc-results">
          <div *ngIf="numberSearchList?.length > 0">
            <ng-container *ngFor="let numberData of numberSearchList; let i = index">
              <div class="loc d-flex flex-row align-items-start">
                <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                  [(ngModel)]="numberData.isSelected" (change)="getNumberCheckedItemList()">
                <span class="checkmark"></span>
                <label class="col-10">
                  {{numberData?.abbreviatedName}} ({{numberData?.uid}})
                </label>
              </div>
            </ng-container>
          </div>
          <div *ngIf="numberEnable && numberSearchList.length == 0">
            <div class="row error-box">
              <div class="col-md-1 img-left">
                <img src="assets/icons/{{baseSiteId}}/confirmation-negative-red.png">
              </div>
              <div class="col-md-10">
                <p>
                  No matches for the entered customer number</p>
                <ul>
                  <li>'{{numberPastedText}}'</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Search">
        <div class="search-box">
          <input type="text" name="searchbox" #searchbox placeholder="Search by customer name or #"
            [(ngModel)]="searchText" (input)="searchCustomer()">
          <button role="presentation" class="search-icon" disabled="">
            <img alt="Search Icon" src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
          </button>
        </div>
        <div class="loc-results">
          <div *ngIf="searchCustomerList.length > 0">
            <ng-container *ngFor="let searchData of searchCustomerList; let i = index">
              <div class="loc d-flex flex-row align-items-start">
                <input type="checkbox" id="checkBox" name="assignedLocation" class="col-2"
                  [(ngModel)]="searchData.isSelected" (change)="getSearchCheckedItemList()">
                <span class="checkmark"></span>
                <label class="col-10">
                  {{searchData?.abbreviatedName}} ({{searchData?.uid}})
                </label>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="modal-footer">
  <button type="button" class="btn-primary" *ngIf="tabSelected == 'Numbers'"
    [disabled]="numberCheckedList.length == 0 || addSubmit" (click)="addCustomer()">
    Add customer(s)
  </button>
  <button type="button" class="btn-primary" *ngIf="tabSelected == 'Search'"
    [disabled]="searchCheckedList.length == 0 || addSubmit" (click)="addCustomer()">
    Add customer(s)
  </button>
  <button type="button" class="btn-secondary" data-dismiss="modal" (click)="cancelPopup()">
    Cancel
  </button>
</div>